import { Detail } from "../types/inspection";
import { PointType } from "../types/workOrder";
import { InspectionPointTypeID } from "../types/enums/item";

export const isPointCompleted = (
  detail: Detail,
  itemType?: number
): boolean => {
  if (
    itemType === 2 &&
    [PointType.Year, PointType.Make, PointType.Model].includes(
      detail.verifyField_ID
    )
  ) {
    return true;
  }

  if (detail.notApplicable) {
    return true;
  } else if ([InspectionPointTypeID.YesNo, InspectionPointTypeID.Verify].includes(detail.type_ID)) {
    return !!detail.answerValue;
  } else if (detail.type_ID === InspectionPointTypeID.Text){
    return !!detail.answerValue;
  } else {
    return detail.photos && detail.photos.length > 0;
  }
};

export const MAX_LIMIT_EDIT_ICON = 250;
export const MAX_LIMIT_EDIT_ICON_VERIFY_ID_TWO_THREE = 50;
export const MAX_LIMIT_64 = 64;
export const MAX_LIMIT_128 = 128;
export const MAX_LIMIT_TEXT = 1000; // For Text type inspection points (type_ID === 1)

export const LIMIT_EXCEED_ERROR_EDIT_ICON =
  "Your input exceeds the 250 character limit";
export const LIMIT_EXCEED_ERROR_EDIT_ICON_VERIFY_ID_TWO_THREE =
  "Your input exceeds the 50 character limit";
export const LIMIT_EXCEED_ERROR_64 =
  "Your input exceeds the 64 character limit.";
export const LIMIT_EXCEED_ERROR_128 =
  "Your input exceeds the 128 character limit.";
export const LIMIT_EXCEED_ERROR_TEXT =
  "Your input exceeds the 1000 character limit.";

/**
 * Gets the character limit and error message for an inspection point.
 * Priority: verifyField_ID specific limits > Text type (type_ID: 1) gets 1000 > default (250)
 * This ensures verifyField_ID limits are never overridden, and Text type points get 1000 chars.
 */
export const getInspectionPointLimit = (
  detail: Detail
): { limit: number; errorMessage: string } => {
  // Priority 1: Check verifyField_ID first (specific field constraints take priority)
  console.log("detail", detail);
  if (
    detail.verifyField_ID === PointType.Make ||
    detail.verifyField_ID === PointType.Model
  ) {
    return {
      limit: MAX_LIMIT_EDIT_ICON_VERIFY_ID_TWO_THREE,
      errorMessage: LIMIT_EXCEED_ERROR_EDIT_ICON_VERIFY_ID_TWO_THREE,
    };
  }

  if (detail.verifyField_ID === PointType.Description) {
    return {
      limit: MAX_LIMIT_64,
      errorMessage: LIMIT_EXCEED_ERROR_64,
    };
  }

  if (detail.verifyField_ID === PointType.StockNumber) {
    return {
      limit: MAX_LIMIT_128,
      errorMessage: LIMIT_EXCEED_ERROR_128,
    };
  }

  // Priority 2: Text type points (type_ID: 1) get 1000 character limit
  if (detail.type_ID === InspectionPointTypeID.Text) {
    return {
      limit: MAX_LIMIT_TEXT,
      errorMessage: LIMIT_EXCEED_ERROR_TEXT,
    };
  }

  // Priority 3: Default fallback for other types (Yes/No, Photo Only, Video Only, etc.)
  return {
    limit: MAX_LIMIT_EDIT_ICON,
    errorMessage: LIMIT_EXCEED_ERROR_EDIT_ICON,
  };
};
